import { useState, useEffect } from "react";
import "./AuditLog.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

const LogTable = ({ schema, logs, page, handlePageChange, pageAmount }) => {
  const [isMorePage, setIsMorePage] = useState(false);

  useEffect(() => {
    if (page === pageAmount) {
      setIsMorePage(false);
    } else {
      setIsMorePage(true);
    }
  }, [page ]);

  if (!schema || !schema.columns) return null;
  return (
    <div className="tableSection">
      {page > 1 ? (
        <button 
        className="pageButton"
        onClick={() => handlePageChange(page - 1)}>
          -
        </button>
      ) : null}
      <span style={{ color: "black" }}>Page {page}</span>
      {isMorePage && (
        <button 
        className="pageButton"
        onClick={() => handlePageChange(page + 1)}>
          +
        </button>
      )}
      <TableContainer component={Paper} sx={{marginBottom:"20px"}}>
        <Table sx={{ width: 1000 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {schema.columns.map((column) => (
                <TableCell key={column.key}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {schema.columns.map((column) => (
                  <TableCell component="th" scope="row">
                    {log[column.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
export default LogTable;
